module.exports = __webpack_public_path__ + "media/images/account/icon6-458587b863992cfe20d16aa8c2f647a7.svg";